import './App.css'
import GlobalStyle from '@src/Theme/globalStyles'
import ErrorBoundary from '@src/Components/ErrorBoundary'
import { Provider as RollbarProvider } from '@rollbar/react'
import { createTheme, MantineProvider } from '@mantine/core'
import '@mantine/core/styles.css'
import Router from '@src/Router'
import { useEffect, useMemo, useState } from 'react'
import { useAuthStore } from '@wove/api'
import { Provider } from 'urql'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { getApiUrl, getToken } from '@src/authStore'
import { Spinner } from '@wove/web-ui'
import { Toaster } from 'sonner'
import { createClient } from './urqlClient'

const theme = createTheme({
  /** Put your mantine theme override here */
})

const rollbarConfig = {
  accessToken: '9f86faa82b81420abbb56933c5abffc2',
  environment: process.env.NODE_ENV,
}

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

const App = () => {
  const [initialized, setInitialized] = useState(false)
  const authStore = useAuthStore()

  // Create a stable client reference that won't change
  const [client] = useState(() => {
    // Get initial values synchronously
    const token = getToken()
    const baseUrl = import.meta.env.VITE_API_BASE_URL || undefined
    return createClient(token || undefined, baseUrl)
  })

  useEffect(() => {
    authStore.setApiUrl(getApiUrl())
    const token = getToken()
    if (token) {
      authStore.setAccessToken(token)
    }
    setInitialized(true)
  }, [])

  if (!initialized) {
    return <Spinner />
  }

  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme}>
        <RollbarProvider config={rollbarConfig}>
          <ErrorBoundary>
            <Provider value={client}>
              <GlobalStyle />
              <Toaster />
              <Router />
            </Provider>
          </ErrorBoundary>
        </RollbarProvider>
      </MantineProvider>
    </QueryClientProvider>
  )
}

export default App
